import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(userId: string, requestBody: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.USER}/User/${userId}`;
	return axios.put(url, requestBody).toOptionalVoid();
}

export interface Request {
	firstName: string;
	lastName: string;
	email: string;
	languageId: string;
	profilePictureId: string | undefined;
	userSettings: UserSettingsApi | null;
	roles: string[] | null;
	isActive: boolean;
}

export type UserSettingsApi = {
	'Price.Currency'?: string;
	'Recipe.List.ValueScope': ValueScope;
	'Preferred.Nutrient.Ids'?: string;
};

export enum ValueScope {
	Total = 'Total',
	Person = 'Person',
	Parts = 'Parts',
	HundredGrams = 'HundredGrams',
}
